export default {
  "Fintech_Credit_process_HZXM_aphO": "Lo sentimos, no se pudo revisar tu solicitud en {{number}} minutos debido a un error de la red.",
  "Fintech_Credit_0903_itlb_txsV": "Descarga la aplicación para acceder más rápido a tu dinero",
  "Fintech_Credit_MGM_FRze_wbCU": "Ya eres cliente de {{brandname1}}. Esta recompensa es solo para usuarios que aún no se han registrado.",
  "Fintech_Credit_users_Fgor_OikJ": "Ingresa tu celular",
  "Fintech_Credit_process_Guey_Ppwk": "Descarga la aplicación para agregar más datos y obtener la aprobación de tu límite en solo {{number}} minutos.",
  "Fintech_Credit_0903_Fdiw_IPya": "Lo sentimos, tu CURP ya está registrada en otra cuenta",
  "Fintech_Credit_process_KQiP_aOSy": "Siguiente",
  "Fintech_Credit_process_Hxcn_fgVI": "Descargar",
  "Fintech_Credit_MGM_zPxE_bpxU": "Lo sentimos, no cumples con los requisitos de la promoción.",
  "Fintech_Credit_MGM_YitB_QNUR": "Ver en la aplicación",
  "Fintech_Credit_MGM_jRsA_aJyu": "Puedes explorar otras promociones",
  "Fintech_Credit_MGM_KdwC_pihh": "¿No es tu número de celular? {{phone_number}}",
  "Fintech_Credit_process_HYaW_sMHh": "Por favor, intenta descargar la aplicación para acelerar la revisión de tu solicitud.",
  "Fintech_Credit_process_bbcs_magE": "Conoce {{brand}}",
  "Fintech_Credit_MGM_wkzA_UVSR": "Cambiar",
  "Fintech_Credit_MGM_MVYs_hWXy": "Abrir aplicación",
  "GRider_loginsdk_Start_hvEU": "Comencemos",
  "Fintech_Credit_process_FLYH_ptUA": "Ocurrió un error. Por favor, intenta descargar la aplicación para una solicitud más rápida.",
  "financial": {
    "loan": {
      "freya": {
        "home": {
          "uncredit": {
            "apply_btn_new": "Ver límite"
          },
          "brand": {
            "desc4": "Revisión rápida",
            "desc2": "Solicítalo en la app",
            "desc5": "Fácil de pagar"
          }
        },
        "brand": {
          "name": "DiDi Préstamos"
        }
      }
    }
  },
  "Fintech_Credit_0903_hIKU_CqSz": "Depósito en 2 min",
  "Fintech_Payment_revamp2_dNGb_piVd": "No te pierdas un límite de crédito de hasta {{{amount}}}",
  "Fintech_Credit_0903_ovak_WqBx": "Por motivos de seguridad, descarga la aplicación para volver a vincular tu CURP y completa la solicitud",
  "Fintech_Credit_M2_Law_eoDk": "Documentos legales",
  "Fintech_Credit_process_vJez_RxPi": "Para ayudarnos a procesar mejor tu solicitud, cuéntanos más sobre ti.",
  "financial_loan_freya_credit_register_pop__2_description": "Para proteger tus derechos, lee y acepta el {{agreement_name1}} y los {{agreement_name2}}",
  "Fintech_Credit_MGM_dCnh_VUbF": "Lo sentimos, la promoción ha finalizado",
  "Fintech_Credit_optimization_Sufa_QPAG": "Por favor, acepta el acuerdo antes de ver tu límite"
}